import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { usePrevious } from 'swag-client-common/utils/hooks';
import ImbaImage from '../imba-image';
import Loading from '../../info/loading';
import classes from './image.scss';
import { shouldShowSuperSpeedLabel } from './utils';
const Image = ({
  src,
  alt,
  getRef,
  style,
  isBlurMode,
  isLE,
  isSuperSpeed,
  imageStyle,
  className = '',
  dataImage = '',
  wrapperClassName = '',
  loadingClassName = '',
  LEClassName = '',
  superSpeedClassName = '',
  loadingSize,
  onClick,
  onLoad,
  onError
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const prevSrc = usePrevious(src);
  useEffect(() => {
    if (prevSrc !== src) {
      setIsLoading(true);
    }
  }, [src]);
  const onSuccessImageLoad = () => {
    onLoad && onLoad();
    setIsLoading(false);
  };
  const onErrorImageLoad = () => {
    onError && onError();
    setIsLoading(false);
  };
  if (isBlurMode) {
    return /*#__PURE__*/React.createElement(ImbaImage, {
      src: src,
      alt: alt
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-image": dataImage,
    className: classnames(classes.wrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement("img", {
    className: className,
    src: src,
    alt: alt,
    ref: getRef,
    onLoad: onSuccessImageLoad,
    onError: onErrorImageLoad,
    onClick: onClick,
    style: imageStyle
  }), isLE && /*#__PURE__*/React.createElement("div", {
    className: LEClassName
  }, "Limited\xA0Edition"), shouldShowSuperSpeedLabel({
    isSuperSpeed
  }) && /*#__PURE__*/React.createElement("div", {
    className: superSpeedClassName
  }, "Super Speed"), isLoading && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.placeholder, loadingClassName),
    style: style
  }, /*#__PURE__*/React.createElement(Loading, {
    size: loadingSize
  })));
};
export default Image;